import defaultSettings from '@/settings'
import { uuid2 } from '@/utils/tools'
import { formTypes } from '@/views/setting/evaluationTable/constants'

const { showSettings, tagsView, fixedHeader, sidebarLogo } = defaultSettings

const state = {
  theme: '',
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  dialogPreviewVisible: false,
  dialogBasicInfoVisible: false,
  editingDimensionIndex: null,
  editingQuestionIndex: null,
  editingEvaluationTableItem: {
    dimensionId: null,
    questionId: null
  },
  editingFormItem: null,
  dialogConfirmVisible: false,
  dialogConfirmTip: {
    formType: 1,
    title: '',
    desc: '',
    updateOptionsVisible: false,
  },
  confirmFunction: null,
  _editingEvaluationTableItem: {
    dimensionId: null,
    questionId: null
  },
  isDraggingAdd: false,
  currentFormType: formTypes.interviewEvaluation,
  editingEvaluationTable: {},
  _editingEvaluationTable: {
    id: '12456',
    formType: formTypes.interviewEvaluation, // 评价表类型
    name: '评价打分表04', // 标题
    instruction: '', // 描述文字
    scene: 1, // 招聘场景：1社会招聘，2校园招聘
    questionType: 1, // 评价表题目类型 系统计分
    userIds: [], // 共享人
    depts: [], // 共享部门
    scoreType: '', // 非系统计分  系统计分-总分 系统计分-权重
    weightType: [], // 开启维度权重 开启题目权重
    fullScore: 5, // 系统计分-单选 每题满分
    maxStar: 5, // 评星题-最大星数
    minScore: 1, // 打分题-打分区间-最小
    maxScore: 100, // 打分题-打分区间-最大
    // sharedUsers: [], // 共享人
    // sharedDepartments: [], // 共享部门
    // sceneType: '', // 校园招聘 社会招聘
    // questionCfg: '[]', // 题目配置-JSON
    dimensions: [{
      id: '维度aaa',
      title: '维度-aaaa',
      description: 'abcdefg hijklmn opqrst',
      weight: 0,
      questions: []
    }, {
      id: '维度-12345',
      title: '维度-12345',
      description: '12345 上山打老虎',
      weight: 0,
      questions: []
    }, {
      id: '111',
      title: '这是维度1',
      description: '喵喵喵',
      weight: 0,
      questions: [{
        id: '1',
        formItemType: 'singleChoice',
        title: '问题-不计分单选',
        description: '这是一个不计分单选，嘻嘻嘻呵呵呵哈哈哈喵喵喵',
        hasScore: false, // 计分  false不计分
        isRequired: true,
        enableComment: false,
        isCommentRequired: false,
        commentTip: '',
        fullScore: 15,
        hideOptionScore: false,
        displayType: 'select', // vertical horizontal
        options: [{
          optionId: 1,
          name: '选项1',
          value: 1,
          score: 10
        }, {
          optionId: 2,
          name: '选项2',
          value: 2,
          score: 5
        }, {
          optionId: 3,
          name: '选项3',
          value: 3,
          score: 0
        }],
        linkageRules: []
      }, {
        id: '7',
        formItemType: 'singleChoice',
        title: '计分单选',
        description: '这是一个计分单选，嘻嘻嘻呵呵呵哈哈哈喵喵喵',
        hasScore: true, // 计分  false不计分
        isRequired: true,
        enableComment: false,
        isCommentRequired: false,
        commentTip: '',
        fullScore: 15,
        hideOptionScore: false,
        displayType: 'select', // vertical horizontal
        options: [{
          optionId: 1,
          name: '计分-选项1',
          value: 1,
          score: 10
        }, {
          optionId: 2,
          name: '计分-选项2',
          value: 2,
          score: 5
        }, {
          optionId: 3,
          name: '计分-选项3',
          value: 3,
          score: 0
        }],
        linkageRules: [],
        value: ''
      }, {
        id: '2',
        formItemType: 'multiChoice',
        title: '问题-多选',
        description: '这是一个多选，嘻嘻嘻呵呵呵哈哈哈喵喵喵',
        isRequired: true,
        enableComment: false,
        isCommentRequired: false,
        commentTip: '',
        displayType: 'vertical',
        options: [{
          optionId: 1,
          name: '选项AAA',
          value: 1,
          score: 0
        }, {
          optionId: 2,
          name: '选项BBB',
          value: 2,
          score: 0
        }, {
          optionId: 3,
          name: '选项DDD',
          value: 3,
          score: 0
        }],
        linkageRules: [],
        value: []
      }, {
        id: '3',
        formItemType: 'textInput',
        title: '问题-文本',
        description: '这是一个文本输入框，嘻嘻嘻呵呵呵哈哈哈喵喵喵',
        isRequired: true,
        enableComment: false,
        isCommentRequired: false,
        commentTip: '',
        linkageRules: []
      }, {
        id: '4',
        formItemType: 'scoreInput',
        title: '打分题~~',
        description: '这是一个打分题，嘻嘻嘻呵呵呵哈哈哈喵喵喵',
        hasScore: true, // 计分  false不计分
        isRequired: true,
        enableComment: false,
        isCommentRequired: false,
        commentTip: '',
        minScore: 33,
        maxScore: 77,
        weight: 0.66,
        linkageRules: []
      }, {
        id: '99',
        formItemType: 'star',
        title: '评星题~~',
        description: '这是一个评星题，嘻嘻嘻呵呵呵哈哈哈喵喵喵',
        hasScore: true, // 计分  false不计分
        isRequired: true,
        enableComment: false,
        isCommentRequired: false,
        commentTip: '',
        minScore: 33,
        maxScore: 77,
        weight: 0.66,
        fullScore: 7, // 星星数量
        linkageRules: []
      }]
    }, {
      id: 'd8cd30db-ed04-4658-91f0-2c132ddd9271',
      'title': '面试结论',
      'description': null,
      'weight': 0,
      isConclusion: true,
      'questions': [
        {
          'id': 'sdfasd',
          formItemType: 'conclusionResult',
          isConclusionDefault: true,
          needPendingOption: true,
          'isRequired': true,
          'title': '面试结果(必填)',
          'description': null,
          'type': 0,
          'conclusionQuestionType': 1,
          'enableComment': false,
          'ssCommentRequired': false,
          'PCShowStyle': null,
          'questionWeight': 1,
          'hideOptionScore': false,
          'fullScore': null,
          'commentTips': null,
          'options': [{
            optionId: '1',
            name: '通过'
          }, {
            optionId: '2',
            name: '待定'
          }, {
            optionId: '3',
            name: '淘汰'
          }],
          'inspectionAbilities': [],
          'recommendQuestions': [],
          linkageRules: []
        },
        {
          'id': '2132',
          title: '得分',
          formItemType: 'conclusionScore',
          isConclusionDefault: true,
          enabled: false,
          isRequired: false,
          scoreType: 'number', // number数字   start评星
          maxStar: 5,
          minScore: 0,
          maxScore: 100,
          precision: 1, // 精度  1 和 0.1
          'description': null,
          'type': 0,
          'conclusionQuestionType': 2,
          'enableComment': false,
          'isCommentRequired': false,
          'PCShowStyle': null,
          'questionWeight': 1,
          'hideOptionScore': false,
          'fullScore': null,
          'commentTips': null,
          'options': [],
          'inspectionAbilities': [],
          'recommendQuestions': []
        },
        {
          id: '213sadas',
          title: '综合评价',
          formItemType: 'conclusionComment',
          isConclusionDefault: true,
          enabled: false,
          isRequired: false,
          minLength: 10,
          maxLength: 1500,
          'description': null,
          'type': 0,
          'conclusionQuestionType': 3,
          'enableComment': false,
          'isCommentRequired': false,
          'PCShowStyle': null,
          'questionWeight': 1,
          'hideOptionScore': false,
          'fullScore': null,
          'commentTips': null,
          'options': [],
          'inspectionAbilities': [],
          'recommendQuestions': []
        }
      ]
    }]
  },
  currentEditQuestion: null,
  requiredTagVisible: false,
  rolePageConfig: {},
  searchParams: {}
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  setDialogPreviewVisible(state, value) {
    state.dialogPreviewVisible = value
  },
  updateEditingEvaluationTableItem(state, value) {
    state.editingEvaluationTableItem = value
  },
  setCurrentEditQuestion(state, value) {
    state.currentEditQuestion = value
  },
  deleteDimension(state, index) {
    state.editingEvaluationTable.dimensions.splice(index, 1)
  },
  deleteQuestion(state, value) {
    state.editingEvaluationTable.dimensions[value.dimensionIndex].questions.splice(value.questionIndex, 1)
  },
  addDimension(state, value) {
    state.editingEvaluationTable.dimensions.splice(value.dimensionIndex, 0, value.dimension)
  },
  addQuestion(state, value) {
    state.editingEvaluationTable.dimensions[value.dimensionIndex].questions.splice(value.questionIndex, 0, value.question)
  },
  updateIsDraggingAdd(state, value) {
    state.isDraggingAdd = value
  },
  setCurrentFormType(state, value) {
    state.currentFormType = value
  },
  setRequiredTagVisible(state, value) {
    state.requiredTagVisible = value
  },
  setEditingFormItem(state, value) {
    state.editingFormItem = value
  },
  setRolePageConfig(state, value) {
    state.rolePageConfig = value
  },
  SET_SEARCH_PARAMS: (state, data) => {
    if(data.key){
      state.searchParams[data.key] = data.value
    }else{
      state.searchParams = data
    }
  },
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
